import type { components } from "../api/generated/survey-svc";

export type UserRole = components["schemas"]["AuthMe"]["currentUser"]["role"];

export function hasRole(
  user: { role?: string | null } | null | undefined,
  requiredRoles: readonly UserRole[],
): boolean {
  if (user?.role !== "Admin" && user?.role !== "Customer") return false;
  return (
    requiredRoles.length === 0 ||
    requiredRoles.some((role) => role === user.role)
  );
}
